import { clearPersistStorage } from '../../utils/storage'

import type { Middleware } from 'redux'

const REQUEST_LOGOUT = 'REQUEST_LOGOUT'

export const sessionLogoutStorageMiddleware: Middleware = () => (next) => (action) => {
  const result = next(action)

  if (
    typeof action === 'object' &&
    action !== null &&
    'type' in action &&
    (action as { type?: string }).type === REQUEST_LOGOUT
  ) {
    clearPersistStorage('')
  }

  return result
}
